var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
  let { isLoggedIn, canonical, isSaveable, listingId, leadSubmitted, resId, shareModalTarget, isLeadFormSuppressed,
          isPreFetch, propertyStatus, pageType, ctaButtonName, storeLink, bannerAttr, showOpenInAppCTA, ctaText,
          isDesktop, isShareNewHomeEnabled, propertyType ,
          name, new_community_name, hasSuppressLeadForm, isSpecHome } = options; 
__p+='\n\n';
 let ctaText_submit = "Contact Agent" 
__p+='\n';
 let abEmailClass = '', abEmailTextClass = '', newPlan = false; 
__p+='\n';
 if (propertyType && propertyType === 'new_plan') { 
__p+='\n  ';
 newPlan = true 
__p+='\n';
 } 
__p+='\n\n';
 if(ctaText == 'V1' && ctaButtonName == "Contact Agent") { 
__p+='\n  ';
 ctaButtonName = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n';
 if (!newPlan){ 
__p+='\n  ';
 if (!leadSubmitted && isDesktop) { 
__p+='\n    ';
 abEmailClass = "ab-email-desktop"; 
__p+='\n    ';
 abEmailTextClass = "ab-email-header-cta-text"; 
__p+='\n  ';
 } else { 
__p+='\n    ';
 abEmailClass = ""; 
__p+='\n    ';
 abEmailTextClass = ""; 
__p+='\n  ';
 } 
__p+='\n';
 } 
__p+='\n\n';
 let title = newPlan ? 'Tell me more about this plan' : 'Tell me more about this property' 
__p+='\n';
 const propertyText = name && name.toLowerCase().includes('plan') ? `${name}` : `${name} plan` 
__p+='\n';
 let placeholder = newPlan ? `I am interested in ${propertyText} in the ${new_community_name} community` : 'Request Details' 
__p+='\n\n<a href="javascript:void(0)" class="qv-close-back" id="qv-close-back" data-omtag="'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp-quickview:sticky:close">\n  <i class="ra ra-angle-left"></i>\n</a>\n  ';
 if(isPreFetch) { 
__p+='\n    <a href="javascript:void(0);" class="header-contact-agent">\n      '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n    </a>\n  ';
 } else if (!isLeadFormSuppressed) { 
__p+='\n    ';
 if (!newPlan) { 
__p+='\n      ';
 if (hasSuppressLeadForm) { 
__p+='\n        <a href="javascript:void(0);" id="header-contact-agent-container" class="js-hide-ajax-fail header-contact-agent ';
 if (leadSubmitted) { 
__p+='contacted';
 } else { 
__p+='js-qv-contact-agent';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+='data-omtag= "'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp-quickview:sticky:contact_agent" data-formid="secondary"';
 } 
__p+=' sticky-contact-agent>\n          <span id="header-contact-agent" class="'+
((__t=( abEmailClass ))==null?'':__t)+
'"></span><span class="'+
((__t=( abEmailTextClass ))==null?'':__t)+
'">';
 if (leadSubmitted) { 
__p+='Contacted';
 } else { 
__p+=''+
((__t=( ctaButtonName ))==null?'':__t)+
'';
 } 
__p+='</span>\n        </a>\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      <a href="javascript:void(0);" class="js-hide-ajax-fail header-contact-agent ';
 if (leadSubmitted) { 
__p+='contacted';
 } else { 
__p+='js-qv-contact-agent';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+='data-omtag= "'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp-quickview:sticky:contact_agent" data-formid="secondary"';
 } 
__p+=' sticky-contact-agent>\n          ';
 if (leadSubmitted) { 
__p+='Contacted';
 } else { 
__p+=''+
((__t=( ctaButtonName ))==null?'':__t)+
'';
 } 
__p+='\n      </a>\n    ';
 } 
__p+='\n  ';
 } 
__p+='\n\n  <a href="'+
((__t=( canonical ))==null?'':__t)+
'" target="_blank" class="pull-right ldp-link header-ldp-link" data-omtag="ldp:quickview:sticky:expand">\n    <i class="ra ra-external-link"></i>\n    <span>View Full Details</span>\n  </a>\n\n  ';
 if(isPreFetch && !isSpecHome) { 
__p+='\n    <a href="javascript:void(0)" class="js-hide-ajax-fail qv-favorite">\n      <i class="ra ra-heart-o"></i>\n      <span>Save</span>\n    </a>\n  ';
 } else if (isSaveable !== undefined && listingId && !isSpecHome) { 
__p+='\n    <a href="javascript:void(0)" data-omtag="'+
((__t=( propertyStatus == 'new_community' ? 'ready_to_biuld' : propertyStatus  ))==null?'':__t)+
':ldp-quickview:top:listing_save" class="js-hide-ajax-fail qv-favorite ';
 if (isLoggedIn) { 
__p+='qv-';
 if (isSaveable) { 
__p+='un';
 } 
__p+='save';
 } else { 
__p+='qv-save-not-logged-in';
 } 
__p+='" data-listingid="'+
((__t=( listingId ))==null?'':__t)+
'" ';
 if (isSaveable) { 
__p+='data-res-id="'+
((__t=( resId ))==null?'':__t)+
'"';
 } 
__p+='>\n      <i class="ra ra-heart';
 if (!isSaveable) { 
__p+='-o';
 } 
__p+='"></i>\n      <span>Save';
 if (isSaveable) { 
__p+='d';
 } 
__p+='</span>\n    </a>\n  ';
 } 
__p+='\n\n  ';
 if (listingId || (MOVE_DATA.adobeDTM.propertyStatusSub === 'new_plan' && isShareNewHomeEnabled)) { 
__p+='\n    <a href="javascript:void(0)" class="js-hide-ajax-fail header-share display-btn" data-toggle="modal" data-target="'+
((__t=( shareModalTarget ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp-quickview:top:share">\n      <i class="ra share-icon"></i>\n      <span>Share</span>\n    </a>\n  ';
 } 
__p+='\n\n  <a href="javascript:void(0)" class="qv-close pull-right" aria-label="close quick view" id="qv-close" data-omtag="'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp-quickview:sticky:close">\n    <i class="ra ra-close-thin"></i>\n  </a>\n\n  <div class="tabs" style="display:none">\n      <ol class="immersive-tabs"></ol>\n  </div>\n\n  <a href="javascript:void(0)" class="full-gallery-close pull-right">\n    <i class="ra ra-close-thin"></i> Exit Gallery\n  </a>\n\n  ';
 if (showOpenInAppCTA) { 
__p+='\n    <a href="'+
((__t=( storeLink ))==null?'':__t)+
'" class="btn btn-primary round-cta btn-open-app font-semibold" data-omtag="'+
((__t=( propertyStatus ))==null?'':__t)+
':ldp_quickview:top:open_in_app" style="'+
((__t=( bannerAttr["btn_clr"] ))==null?'':__t)+
''+
((__t=( bannerAttr["cta_clr"]))==null?'':__t)+
'">Open In App</a>\n  ';
 } 
__p+='\n\n  <a href="javascript:void(0)" class="full-map-close pull-right">\n    <i class="ra ra-close-thin"></i> Exit Map\n  </a>\n\n\n  <div class="amenities-ad no-show">\n    <div id="div-gpt-ad-MAPAD4" class="mapad4"></div>\n    <div id="div-gpt-ad-MAPEXP1" class="mapexp1"></div>\n  </div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-header.jst.ejs